import React from 'react';
import PropTypes from 'prop-types';
import ReactGA from 'react-ga';
import { Route, Switch, Redirect } from 'react-router-dom';

import BusinessProfileSummary from './BusinessProfileSummary';
import SoftwareSetupContainer from '../../containers/SoftwareSetupContainer';
import PhoneSetupContainer from '../../containers/PhoneSetupContainer';

import './index.scss';

export default class BusinessProfile extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      mindBodySetupVisibility: false,
      phoneSetupVisibility: false,
    };

    this.onPhoneEditClick = this.onPhoneEditClick.bind(this);
    this.onMindBodyEditClick = this.onMindBodyEditClick.bind(this);
  }

  componentDidMount() {
    ReactGA.pageview(window.location.hash);
    ReactGA.event({
      category: 'User',
      action: 'Click on Setup Tab',
      label: 'Setup Page',
    });
  }
  onPhoneEditClick() {
    this.props.history.push('/app/setup/phone');
  }

  onMindBodyEditClick() {
    const { history } = this.props;

    // Reset software selected status if not already verified
    if (this.props.dashboard.tasksStatus.bookingSW_connect !== 'completed') {
      this.props.resetSelectedSoftware();
    }

    history.push('/app/setup/software');
  }

  render() {
    const { dashboard } = this.props;

    let welcomeMessage = '';
    if (
      dashboard.tasksStatus.bookingSW_connect !== 'completed' &&
      dashboard.tasksStatus.call_forwarding !== 'completed'
    ) {
      welcomeMessage =
        'This is the place to start! Setup your booking software and phone';
    } else if (
      dashboard.tasksStatus.bookingSW_connect !== 'completed' ||
      dashboard.tasksStatus.call_forwarding !== 'completed'
    ) {
      welcomeMessage =
        'Your setup is incomplete! Needs your immediate attention!';
    } else if (
      dashboard.tasksStatus.bookingSW_connect === 'completed' &&
      dashboard.tasksStatus.call_forwarding === 'completed'
    ) {
      welcomeMessage = 'Basic information is complete';
    }

    return (
      <div className="basic-information">
        <p className="basic-information__text">{welcomeMessage}</p>

        <Route
          exact
          path="/app/setup"
          render={() => <Redirect to="/app/setup/summary" />}
        />
        <Switch>
          <Route
            path="/app/setup/summary"
            render={(props) => (
              <BusinessProfileSummary
                {...props}
                {...this.props}
                onPhoneEditClick={this.onPhoneEditClick}
                onMindBodyEditClick={this.onMindBodyEditClick}
              />
            )}
          />
          <Route
            path="/app/setup/software"
            render={(props) => <SoftwareSetupContainer {...props} />}
          />
          <Route
            path="/app/setup/phone"
            render={(props) => <PhoneSetupContainer {...props} />}
          />
        </Switch>
      </div>
    );
  }
}

BusinessProfile.defaultProps = {
  resetSelectedSoftware: () => {},
  dashboard: {},
  router: {
    push: () => {},
  },
};

BusinessProfile.propTypes = {
  resetSelectedSoftware: () => {},
  dashboard: PropTypes.shape({
    tasksStatus: PropTypes.shape({
      call_forwarding: PropTypes.string,
      bookingSW_connect: PropTypes.string,
    }),
  }).isRequired,
  router: PropTypes.shape({
    push: PropTypes.func,
  }),
};
